import React, { useRef, useEffect } from 'react';
import { Card, Form } from 'react-bootstrap';
import { FaPaperPlane } from 'react-icons/fa';

const InputBox = ({
  isFixed,
  userInput,
  setUserInput,
  handleSendMessage,
  sidebarOffset = 0,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const containerStyle = isFixed
    ? {
        position: 'fixed',
        bottom: 0,
       transition: 'left 180ms ease, width 180ms ease',
        width: `calc(100% - ${sidebarOffset}px)`,
        left: sidebarOffset,
        background: '#fff',
        padding: '0 0 1rem 0',
        zIndex: 1000,
      }
    : { marginTop: '1rem' };

  return (
    <div style={containerStyle}>
      <Card
        className="w-100 p-3"
        style={{ maxWidth: '700px', margin: '0 auto', borderRadius: '20px' }}
      >
        <Form onSubmit={handleSendMessage}>
          <Form.Group>
            <Form.Control
              ref={inputRef}
              type="text"
              placeholder="Type a question to uncover key metrics and trends instantly..."
              className="border-0 shadow-none mb-3  "
              style={{ fontSize: '1rem' }}
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
            />
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="submit"
                className="rounded"
                style={{
                  width: 36,
                  height: 36,
                  color: '#fff',
                  backgroundColor: '#423894',
                }}
              >
                <FaPaperPlane />
              </button>
            </div>
          </Form.Group>
        </Form>
      </Card>
    </div>
  );
};

export default InputBox;


